import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import useAuthentication from '../../../hooks/useAuthentication';

function UnAuthenticated({ children }) {
  const { isAuthenticated } = useAuthentication();

  if (isAuthenticated()) {
    return null;
  }
  return <Fragment>{children}</Fragment>;
}

UnAuthenticated.propTypes = {
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default UnAuthenticated;
